<template>
	<div>
		<div class="section-gap primary pb-0 mt-6">
			<v-carousel
				cycle
				dark
				hide-delimiter-background
				show-arrows-on-hover
				prev-icon="mdi-chevron-left"
				next-icon="mdi-chevron-right"
				height="400"
			>
				<v-carousel-item v-for="(slide, i) in homeBannerData" :key="i">
					<v-container grid-list-xl py-0>
						<v-layout
							row
							wrap
							align-center
							text-center
							text-sm-center
							text-xl-left
							text-lg-left
						>
							<v-flex xs12 sm12 md6 lg7 xl7>
								<div class="subscribe-content">
									<h1 class="white--text translate-top">
										{{ slide.heading }}
									</h1>
									<p class="white--text translate-right">
										{{ slide.subHeading }}
									</p>
									<v-btn color="accent" to="/demo" rounded
										>🎁 Solicita una demo</v-btn
									>
								</div>
							</v-flex>
							<v-flex xs12 sm12 md6 lg5 xl5>
								<div class="subscribe-content">
									<div class="emb-aside-banner-v1 text-right text-sm-center">
										<img
											class="emb-card"
											alt="aside-banner"
											:src="slide.image"
										/>
									</div>
								</div>
							</v-flex>
						</v-layout>
					</v-container>
				</v-carousel-item>
			</v-carousel>
		</div>
		<div class="main">
			<emb-features :data="featuresData"> </emb-features>

			<lightening-deals
				:data="LighteningDealsData"
				secTitle="Razones para elegir SISLII"
			></lightening-deals>

			<card-items :data="cardData"></card-items>

			<embTestimonial
				secTitle="Mira como Sislii ayuda a nuestros clientes"
				:data="TestimonialData"
			>
			</embTestimonial>

			<banner></banner>

			<div class="section-gap pb-0">
				<subscribe-v2
					heading="Suscríbete a nuestro boletín"
					description="Mantente al día con nuestras últimas novedades y productos"
				></subscribe-v2>
			</div>
		</div>
	</div>
</template>
<script>
import Features from 'Components/Widgets/Feature';
import CardItems from 'Components/Widgets/CardItems';
import LighteningDeals from 'Components/Widgets/LighteningDeals';
import Testimonial from 'Components/Widgets/Testimonial';
import Banner from 'Components/Widgets/BannerV1';
import SubscribeV2 from 'Components/Widgets/SubscribeV2';

// data
import homeBannerData from 'Assets/data/homeBannerData';
import featuresData from 'Assets/data/featuresData';
import cardData from 'Assets/data/cardData';
import LighteningDealsData from 'Assets/data/lighteningDealsData';
import TestimonialData from 'Assets/data/TestimonialData';

export default {
	components: {
		embFeatures: Features,
		cardItems: CardItems,
		lighteningDeals: LighteningDeals,
		embTestimonial: Testimonial,
		Banner: Banner,
		subscribeV2: SubscribeV2,
	},
	inject: ['theme'],
	data() {
		return {
			homeBannerData,
			featuresData,
			cardData,
			LighteningDealsData,
			TestimonialData,
		};
	},
};
</script>
